import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, ShieldCheck, Sparkles, Users, Wallet } from "lucide-react";

const InfoPage = ({ variant = "klanten" }) => {
  const { t } = useTranslation();
  const isKlanten = variant === "klanten";
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <section className="bg-gradient-to-b from-amber-50/60 to-white">
        <div className="max-w-5xl mx-auto px-4 md:px-8 py-16 md:py-20">
          <span className="pill-amber">{isKlanten ? t("info_page.klanten_badge") : t("info_page.kantoren_badge")}</span>
          <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-[#1A2B4A] mt-4 leading-tight tracking-tight">
            {isKlanten ? t("info_page.klanten_title") : t("info_page.kantoren_title")}
          </h1>
          <p className="text-lg text-slate-600 mt-4 max-w-2xl">
            {isKlanten ? t("info_page.klanten_subtitle") : t("info_page.kantoren_subtitle")}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link to={isKlanten ? "/onboarding" : "/login"} className="btn-amber" data-testid="info-cta-primary">
              {isKlanten ? t("info_page.klanten_cta") : t("info_page.kantoren_cta")} <ArrowRight size={16} />
            </Link>
            <Link to="/" className="btn-outline-navy" data-testid="info-cta-back">{t("info_page.back_home")}</Link>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="grid md:grid-cols-3 gap-6">
            {(isKlanten
              ? [
                  { icon: Sparkles, t: t("info_page.klanten_b1_title"), d: t("info_page.klanten_b1_desc") },
                  { icon: ShieldCheck, t: t("info_page.klanten_b2_title"), d: t("info_page.klanten_b2_desc") },
                  { icon: Wallet, t: t("info_page.klanten_b3_title"), d: t("info_page.klanten_b3_desc") },
                ]
              : [
                  { icon: Users, t: t("info_page.kantoren_b1_title"), d: t("info_page.kantoren_b1_desc") },
                  { icon: Wallet, t: t("info_page.kantoren_b2_title"), d: t("info_page.kantoren_b2_desc") },
                  { icon: Sparkles, t: t("info_page.kantoren_b3_title"), d: t("info_page.kantoren_b3_desc") },
                ]
            ).map((b, i) => {
              const Icon = b.icon;
              return (
                <div key={i} className="beecenter-card p-6">
                  <div className="w-12 h-12 rounded-xl bg-[#F5A623]/10 text-[#F5A623] flex items-center justify-center"><Icon size={22} /></div>
                  <h3 className="font-heading font-bold text-lg text-[#1A2B4A] mt-4">{b.t}</h3>
                  <p className="text-sm text-slate-600 mt-2 leading-relaxed">{b.d}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-16 beecenter-card p-8 md:p-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#1A2B4A]">{t("info_page.faq_title")}</h2>
            <div className="mt-6 grid md:grid-cols-2 gap-6">
              {[
                { q: isKlanten ? t("info_page.klanten_q1") : t("info_page.kantoren_q1"), a: isKlanten ? t("info_page.klanten_a1") : t("info_page.kantoren_a1") },
                { q: t("info_page.q2"), a: t("info_page.a2") },
                { q: isKlanten ? t("info_page.klanten_q3") : t("info_page.kantoren_q3"), a: isKlanten ? t("info_page.klanten_a3") : t("info_page.kantoren_a3") },
                { q: t("info_page.q4"), a: t("info_page.a4") },
              ].map((f, i) => (
                <div key={i}>
                  <div className="font-heading font-bold text-[#1A2B4A]">{f.q}</div>
                  <p className="text-sm text-slate-600 mt-1">{f.a}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default InfoPage;
